import { PhoneNumberUtil } from 'google-libphonenumber';

export const roundNumber = (number, numberOfDigits) => {
  let base = 1;

  for (let i = 0; i < numberOfDigits; i++) {
    base *= 10;
  }
  return Math.round((number + 0.00001) * base) / base;
};

export const calculateProcessingFee = (amount, selectedPaymentMethod) => {
  if (!selectedPaymentMethod) {
    return 0;
  }

  const fee = selectedPaymentMethod.fee || selectedPaymentMethod.fees;
  const amountWithFees = (amount + fee.flat) * (1 + fee.percent / 100);

  return roundNumber(amountWithFees - amount, 2);
};

export const isValidEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const popupCenter = ({ url, title, w = 400, h = 400 }) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
  );

  if (window.focus) newWindow.focus();

  return newWindow;
};

export const getCountryCodeFromNumber = (number) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    return phoneUtil.getRegionCodeForNumber(phoneUtil.parse(number));
  } catch {
    return '';
  }
};

export const isValidPhoneNumber = (phoneNumber) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phoneNumber));
  } catch {
    return false;
  }
};
